import { getTranslation } from '@/utils/parseKeyValueList';
import { Badge } from '../Badge';

export interface ActiveFilter {
  id: string;
  filterId: string;
  filterTitle: string;
  value: string;
  label: string;
}

interface FilterTagsProps {
  activeFilters: ActiveFilter[];
  onRemoveFilter: (filterId: string, value: string) => void;
  onClearAll: () => void;
  t: Record<string, string>;
}

export const FilterTags = ({
  activeFilters,
  onRemoveFilter,
  onClearAll,
  t,
}: FilterTagsProps) => {
  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center h-14 w-full">
      <div
        className="flex items-center gap-2 overflow-x-auto flex-shrink min-w-0 pb-1 lg:[&::-webkit-scrollbar]:h-[6px] lg:[&::-webkit-scrollbar-track]:bg-grey-mid-light lg:[&::-webkit-scrollbar-thumb]:bg-grey-light lg:[&::-webkit-scrollbar-thumb]:rounded lg:[&::-webkit-scrollbar-button]:hidden scrollbar-hide"
        style={{
          scrollbarGutter: 'stable',
        }}
      >
        {activeFilters.map((filter) => (
          <Badge
            text={filter.label}
            key={filter.id}
            badgeColor="BlueDeep"
            onRemove={() => onRemoveFilter(filter.filterId, filter.value)}
          />
        ))}
      </div>
      {activeFilters.length > 1 && (
        <button
          onClick={onClearAll}
          className="text-sm text-gray-600 hover:text-gray-800 ml-2 whitespace-nowrap flex-shrink-0 mt-3 hidden lg:inline-flex"
        >
          {getTranslation(t, 'clear-filters')}
        </button>
      )}
    </div>
  );
};
